<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			新品推荐
		</div>

		<div @click="isShow = !isShow"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加新品推荐
		</div>


		<!-- 	<div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in xptja">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}  <span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;"
							:to="{ path:'/xptjdetail',query:{id:item.id,title:item.title} }">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="isShow">


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						价格:
					</div>
					<el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 550px;">
					<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						上传音频:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_video" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsucesss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileLists">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div> -->

				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>


				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				xsa: false,
				xptja: '',
				form: {
					title: '',
					money: '',
					mp3: '', //mp3
					picture: '', //图片
					content: '', //新品内容
				},
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				fileListss: [],
				fileLists: [],
				qid: '',
			}
		},
		mounted() {
			this.gotosb()
		},
		methods: {
			handlePreview(file) {
				console.log(file);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsucesss(response, file, fileList) {
				this.form.mp3 = response.data.path
			},
			handsuccessss(response, file, fileList) {
				this.form.picture = response.data.path
			},
			xiugaia(val) {
				var sb = true
				var sb2 = 'http://admin.shipoe360.com/public/'
				this.xsa = true
				this.isShow = true
				this.qid = val.id
				this.form.title = val.title
				this.form.money = val.money
				this.form.mp3 = val.mp3
				this.form.picture = val.picture
				this.form.content = val.content
				
				if(this.form.picture === 'http://admin.shipoe360.com/public/'){
					this.form.picture = ''
					sb = true
				} else {
					this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
					sb = false
				}
				console.log(this.form.picture)
				
				if(sb){
					console.log('不用')
				} else {
					let fileArrss = [];
					let fileObjss = {};
					fileObjss.name = "图片";
					fileObjss.url = val.picture;
					fileArrss.push(fileObjss);
					this.fileListss = fileArrss
				}
				
				

				// let fileArrs = [];
				// let fileObjs = {};
				// fileObjs.name = "mp3";
				// fileObjs.url = val.mp3;
				// fileArrs.push(fileObjs);
				// this.fileLists = fileArrs
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					let res = await http.get('api/picture/personl_page_xptj', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.xptja = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				
			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'xp',
					type: 'content',
					mid: '1',
					uid: loginInfo.id
				})
				this.xptja = res.data.data.list.data
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'xp',
					type: 'content',
					mid: '1',
					uid: loginInfo.id,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}
				this.gotosb()
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'xp',
						type: 'content',
						mid: '1',
						fid: '1',
						id: this.qid,
						title: this.form.title,
						content: this.form.content,
						picture: this.form.picture,
						mp3: this.form.mp3,
						money: this.form.money,
						uid: loginInfo.id
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileLists = []
						this.fileListss = []
						this.form.title = ''
						this.form.money = ''
						this.form.mp3 = ''
						this.form.picture = ''
						this.form.content = ''
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'xp',
						type: 'content',
						mid: '1',
						fid: '1',
						title: this.form.title,
						content: this.form.content,
						picture: this.form.picture,
						mp3: this.form.mp3,
						money: this.form.money,
						uid: loginInfo.id
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileLists = []
						this.fileListss = []
						this.form.title = ''
						this.form.money = ''
						this.form.mp3 = ''
						this.form.picture = ''
						this.form.content = ''
					}
				}
			}
		}
	}
</script>

<style>
</style>
